// extracted by mini-css-extract-plugin
export default {"listRoot":"mantineList_listRoot__94lAa","listItemWrapper":"mantineList_listItemWrapper__4w3wW","listItemLabel":"mantineList_listItemLabel__qCinT"};